const dealerNavigatorHelper = (function() {
  const INCREMENT_SIZE = 4;
  let visibleCount = 0;
  let dealers = [];
  let hasCompletedCycle = false;

  return {
    init: function(dealersArray) {
      dealers = [...dealersArray];
      visibleCount = 0;
      hasCompletedCycle = false;
    },
    
    getNext: function() {
      if (hasCompletedCycle) {
        this.reset();
        return this.getNext();
      }

      const newCount = visibleCount + INCREMENT_SIZE;
      
      if (newCount >= dealers.length) {
        visibleCount = dealers.length;
        hasCompletedCycle = true;
      } else {
        visibleCount = newCount;
      }
      
      return dealers.slice(0, visibleCount);
    },
    
    getPrevious: function() {
      hasCompletedCycle = false;
      visibleCount = Math.max(0, visibleCount - INCREMENT_SIZE);
      return dealers.slice(0, visibleCount);
    },
    
    reset: function() {
      visibleCount = 0;
      hasCompletedCycle = false;
    },
    
    getCurrentDealers: function() {
      return dealers.slice(0, visibleCount);
    },
    
    hasMoreDealers: function() {
      // Only returns false when we've shown all dealers AND haven't reset yet
      return !(hasCompletedCycle && visibleCount === dealers.length);
    },
    
    hasCompletedCycle: function() {
      return hasCompletedCycle;
    },
    
    getVisibleCount: function() {
      return visibleCount;
    }
  };
})();

export { dealerNavigatorHelper };